<template>
  <section id="about" class="pt-8 md:pt-12 pb-12 md:pb-16 bg-gray-50">
    <div class="container mx-auto px-4 sm:px-6">
      <div class="grid md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center">
        <div>
          <h3 class="text-xl sm:text-2xl md:text-2xl lg:text-3xl font-bold mb-4 text-primary">Why We Started Safari Strives</h3>
          <!-- Vision & Mission -->
          <div class="mb-6 md:mb-8">
            <h4 class="text-lg sm:text-xl md:text-xl font-bold mb-2 md:mb-3 text-primary">Vision</h4>
            <p class="text-sm sm:text-base md:text-base text-gray-700 leading-relaxed text-justify">To build a world in which economic independence enables individuals and communities to make informed choices, achieve sustainable development, and enjoy a higher quality of life.</p>
          </div>

          <div>
            <h4 class="text-lg sm:text-xl md:text-xl font-bold mb-2 md:mb-3 text-primary">Mission</h4>
            <p class="text-sm sm:text-base md:text-base text-gray-700 leading-relaxed text-justify">To build enterprises that create formal jobs and invest capital in women entrepreneurs so that work in their communities leads to income, security, and ownership.</p>
          </div>
        </div>

        <div>
          <div class="rounded-lg overflow-hidden bg-black shadow-lg">
            <div class="aspect-video">
              <iframe
                src="https://www.youtube.com/embed/njiqUJcuVc4"
                class="w-full h-full"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                loading="lazy"
              >
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({})
export default class VisionMission extends Vue {}
</script>
